<!-- 设计天级统计：新版 - 个人版  -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;margin-bottom: 10px;">设计天级统计：新版</div>
		
		
		<div style="display: flex;flex-wrap: wrap;margin: 10px 0 5px;position: sticky;left: 30px;z-index: 5;" :style="{'width': body_width + 'px'}">
			
			<div class="screen-box">
				<div class="screen-label">投放日期</div>
				<!-- <a-date-picker @change="onChangeDate" :locale="locale"  :allowClear="false" :value="this.moment(endTime, dateFormat)" /> -->
				<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			
			<!-- <div class="screen-box">
				<div class="screen-label">推广人员</div>
				<a-select
					mode="multiple" 
					style="min-width: 200px;"
					placeholder="请选择推广人员"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
					showSearch
				  >
					<a-select-option v-for="(value,key) in tgSelect" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div> -->
			
			<div class="screen-box" >
				<div class="screen-label">媒体平台</div>
				<a-select
					mode="multiple" 
					style="min-width: 200px;"
					placeholder="请选择媒体平台"
					@change="handleChangeB"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
					showSearch
				  >
					<a-select-option :value="1">巨量</a-select-option>
					<a-select-option :value="2">腾讯ADQ</a-select-option>
					<a-select-option :value="3">腾讯MP</a-select-option>
					<a-select-option :value="4">百度</a-select-option>
					<a-select-option :value="5">快手</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">计划类型</div>
				<a-select
					mode="multiple" 
					style="min-width: 200px;"
					placeholder="请选择计划类型"
					@change="handleChangeC"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
					showSearch
				  >
					<a-select-option :value="1">巨量1.0</a-select-option>
					<a-select-option :value="2">巨量2.0</a-select-option>
					<a-select-option :value="3">ADQ广告</a-select-option>
					<a-select-option :value="4">MP广告</a-select-option>
					<a-select-option :value="5">百度单元</a-select-option>
					<a-select-option :value="6">快手广告组</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 17px;">搜索</a-button>
			<a-button @click="exportButton" class="screen-box" type="primary" icon="download">导出</a-button>
			<a-button @click="showCusttomTable" icon="unordered-list"  class="screen-box">自定义列</a-button>
		</div>
	
	</div>
	
	
	<div>
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell" style="cursor: default;" 
				:style="{'width':rableTitle[0].width + 'px'}" >
					{{rableTitle[0].title}}
				</div>
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[1].width + 'px'}" >
					{{rableTitle[1].title}}
				</div>
				<div class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[2].width + 'px'}" >
					{{rableTitle[2].title}}
				</div>
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
			
				<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		<!-- 总计 -->
		<div v-if="tableShowData.length > 0" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index && z_ndex == 0" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						总计
					</div>
					<div v-else-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						
					</div>
				</template>
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) < 0 && b_table_control.indexOf(z_tem.type) < 0" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type]}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && b_table_control.indexOf(z_tem.type) > -1" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{tableSumData[z_tem.type]}}%
				</div>
			</template>
			
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<template v-for="(z_tem,z_ndex) in rableTitle">
					<div v-if="z_ndex <= sticky_index" class="table-td-cell"
					:style="{'width':rableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
			</div>
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type != 'media_platform' && z_tem.type != 'plan_type' && z_tem.type != 'ctr' && z_tem.type != 'eff_roi'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'media_platform'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.media_platform | mediaFilters}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && z_tem.type == 'plan_type'" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.plan_type | planFilters}}
				</div>
				<div v-else-if="z_ndex > sticky_index && z_tem.show_control && (z_tem.type == 'ctr' || z_tem.type == 'eff_roi')" class="table-td-cell"
				 :class="{'text-right': rableTitle[z_ndex].text_right}"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}%
				</div>
			</template>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': body_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
	</div>
	
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="body_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 自定义列 -->
	<a-modal v-model="custtom_visible" width="830px" title="设置自定义列" @ok="customTd" okText="确认" cancelText="取消" >
	    <div style="max-height:500px;overflow-y: overlay;">
			<template  v-for="(d_tem,d_ndex) in customCheckboxData">
				<div class="custom-title">
					<a-checkbox @change="checkboxCustom($event,d_tem)"
					:checked="d_tem.custom_checkbox" style="margin-right: 5px;margin-bottom:7px;"></a-checkbox>
					{{d_tem.label}}
				</div>
				<div class="custom-cell-box">
					<template v-for="(item,index) in rableTitle">
						<div v-if="(d_tem.showTitle.indexOf(item.type) > -1)" 
						:key="item.type" style="width:240px;">
							<a-checkbox @change="onChangeSJ($event,index,d_tem)"
							:checked="item.show_control" style="margin-right: 5px;margin-bottom:7px;">
								{{item.title}}
							</a-checkbox>
						</div>
					</template>
				</div>
			</template>
			
	    </div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { putDataMenu, JLjhPlanDate,  marketersDataDesignList, marketersDataSelectTg } from '@/request/api'
// import JLjhTable from '@/components/JLjhTable.vue'
export default {
	name: 'marketersData_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			titleTab: [
				{label: "投手明细数据", select: true , value: 1 },
				{label: "投手汇总数据", select: false , value: 2 },
			],
			content_type: 1, // 页面内容展现类型
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:70, sort_status:0, type:"id", text_right: false,sort_:90,sort_control: false,show_control: true,},
				{title:"日期",width:90, sort_status:0, type:"date_key", text_right: false,sort_:90,sort_control: false,show_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"推广人员",width:100, sort_status:0, type:"user_name", text_right: false,sort_:89,sort_control: false,show_control: true,},
				
				{title:"媒体平台",width:100, sort_status:0, type:"media_platform", text_right: false,sort_:89,sort_control: false,show_control: true,},
				{title:"计划类型",width:100, sort_status:0, type:"plan_type", text_right: false,sort_:89,sort_control: false,show_control: true,},
				
				{title:"当天新建计划数",width:110, sort_status:0, type:"create_plan_count", text_right: true,sort_:89,sort_control: false,show_control: true,},
				{title:"有消耗的计划数",width:110, sort_status:0, type:"cost_plan_count", text_right: true,sort_:89,sort_control: false,show_control: true,},
				
				{title:"消耗",width:100, sort_status:0, type:"cost", text_right: true,sort_:36,sort_control: true,show_control: true,},
				{title:"展示数",width:100, sort_status:0, type:"show", text_right: true,sort_:36,sort_control: true,show_control: true,},
				{title:"Ecpm",width:100, sort_status:0, type:"avg_show_cost", text_right: true,sort_:36,sort_control: true,show_control: true,},
				{title:"点击数",width:100, sort_status:0, type:"click", text_right: true,sort_:36,sort_control: true,show_control: true,},
				{title:"平均点击单价",width:120, sort_status:0, type:"avg_click_cost", text_right: true,sort_:36,sort_control: true,show_control: true,},
				{title:"点击率",width:100, sort_status:0, type:"ctr", text_right: true,sort_:36,sort_control: true,show_control: true,},
				{title:"转化数",width:100, sort_status:0, type:"convert", text_right: true,sort_:36,sort_control: true,show_control: true,},
				
				{title:"平均转化成本",width:120, sort_status:0, type:"convert_cost", text_right: true,sort_:35,sort_control: true,show_control: true,},
				{title:"转化率",width:100, sort_status:0, type:"convert_rate", text_right: true,sort_:35,sort_control: true,show_control: true,},
				{title:"激活数(巨量)",width:100, sort_status:0, type:"active", text_right: true,sort_:35,sort_control: true,show_control: true,},
				{title:"激活成本(巨量)",width:100, sort_status:0, type:"active_cost", text_right: true,sort_:35,sort_control: true,show_control: true,},
				
				{title:"公众号关注数(ADQ 非微信)",width:130, sort_status:0, type:"from_follow_uv", text_right: true,sort_control: true,show_control: false,},
				{title:"公众号关注成本(ADQ 非微信)",width:130, sort_status:0, type:"from_follow_cost", text_right: true,sort_control: true,show_control: false,},
				{title:"公众号关注数(ADQ/MP 微信)",width:130, sort_status:0, type:"follow_count", text_right: true,sort_control: true,show_control: false,},
				{title:"公众号关注成本(ADQ/MP 微信)",width:130, sort_status:0, type:"follow_cost", text_right: true,sort_control: true,show_control: false,},
				
				{title:"微信调起按钮点击量(百度)",width:130, sort_status:0, type:"weiXinAppButtonConversions", text_right: true,sort_control: true,show_control: false,},
				{title:"微信调起按钮点击成本(百度)",width:130, sort_status:0, type:"weiXinAppButtonConversionsCost", text_right: true,sort_control: true,show_control: false,},
				{title:"微信加粉成功量(百度)",width:130, sort_status:0, type:"weixinFollowSuccessConversions", text_right: true,sort_control: true,show_control: false,},
				{title:"微信加粉成功成本(百度)",width:130, sort_status:0, type:"weixinFollowSuccessConversionsCost", text_right: true,sort_control: true,show_control: false,},
				{title:"微信复制按钮点击量(百度)",width:130, sort_status:0, type:"weiXinCopyConversions", text_right: true,sort_control: true,show_control: false,},
				{title:"微信复制按钮点击成本(百度)",width:130, sort_status:0, type:"weiXinCopyConversionsCost", text_right: true,sort_control: true,show_control: false,},
				
				{title:"封面曝光数(快手)",width:100, sort_status:0, type:"photo_show", text_right: true,sort_control: true,show_control: false,},
				{title:"封面点击数(快手)",width:100, sort_status:0, type:"photo_click", text_right: true,sort_control: true,show_control: false,},
				{title:"封面点击率(快手)",width:100, sort_status:0, type:"photo_click_ratio", text_right: true,sort_control: true,show_control: false,},
				{title:"平均千次曝光花费(元)",width:100, sort_status:0, type:"impression_1k_cost", text_right: true,sort_control: true,show_control: false,},
				{title:"平均点击单价(元)",width:100, sort_status:0, type:"photo_click_cost", text_right: true,sort_control: true,show_control: false,},
				{title:"激活数(快手)",width:100, sort_status:0, type:"activation", text_right: true,sort_control: true,show_control: false,},
				
				{title:"总充值金额",width:120, sort_status:0, type:"eff_total_pay_money", text_right: true,sort_:35,sort_control: true,show_control: true,},
				{title:"总分成金额",width:120, sort_status:0, type:"eff_total_left_money", text_right: true,sort_:35,sort_control: true,show_control: true,},
				
				{title:"ROI",width:100, sort_status:0, type:"eff_roi", text_right: true,sort_:35,sort_control: true,show_control: true,},
				{title:"落地页跳转数",width:120, sort_status:0, type:"user_click", text_right: true,sort_:35,sort_control: true,show_control: true,},
				{title:"当天订单笔数",width:120, sort_status:0, type:"eff_total_order_cnt", text_right: true,sort_:35,sort_control: true,show_control: true,},
				{title:"当天充值用户数",width:130, sort_status:0, type:"eff_total_pay_user_cnt", text_right: true,sort_:35,sort_control: true,show_control: true,},
				{title:"当天充值用户成本",width:145, sort_status:0, type:"eff_total_pay_user_cost", text_right: true,sort_:35,sort_control: true,show_control: true,},
				{title:"回传用户数",width:120, sort_status:0, type:"eff_report_pay_user_cnt", text_right: true,sort_:35,sort_control: true,show_control: true,},
				{title:"回传用户成本",width:120, sort_status:0, type:"eff_report_pay_user_cost", text_right: true,sort_:35,sort_control: true,show_control: true,},
			],
			tableShowData: [],
			tableSumData: {}, // 总计
			sticky_index: 2,
			z_table_control: ['media_platform','plan_type'],
			b_table_control: ['ctr','eff_roi'],
			
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			search_button_loading: false, // 搜索按钮的加载状态
			
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			r_media_platform: undefined, // 媒体平台
			r_plan_type: undefined, // 计划类型
			
			
			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式
			
			r_user_id: [], // 推广人员ID
			
			filterData: {
				op_id:{
					list: [{}],
				},
			}, 
			
			tgSelect: {}, // 推广人员选择器
			
			custtom_visible: false, // 自定义列弹窗
			
			customCheckboxData: [ // 自定义列
				{
					label: "基础数据项",
					showTitle:['media_platform','plan_type',],
					custom_checkbox: true,
					type:"jc"
				},
				{
					label: "投放数据项",
					showTitle:['create_plan_count','cost_plan_count','cost','show','avg_show_cost','click','avg_click_cost','ctr','convert','convert_cost','convert_rate',],
					custom_checkbox: true,
					type:"ty"
				},
				{
					label: "投放数据项（巨量）：",
					showTitle:['active','active_cost'],
					custom_checkbox: true,
					type:"jl"
				},
				{
					label: "投放数据项（腾讯ADQ）：",
					showTitle:['from_follow_uv','from_follow_cost'],
					custom_checkbox: false,
					type:"adq"
				},
				{
					label: "投放数据项（腾讯MP/ADQ）：",
					showTitle:['follow_count','follow_cost'],
					custom_checkbox: false,
					type:"mp"
				},
				{
					label: "投放数据项（百度）：",
					showTitle:['weiXinAppButtonConversions','weiXinAppButtonConversionsCost','weixinFollowSuccessConversions','weixinFollowSuccessConversionsCost','weiXinCopyConversions','weiXinCopyConversionsCost'],
					custom_checkbox: false,
					type:"bd"
				},
				{
					label: "投放数据项（快手）：",
					showTitle:['photo_show','photo_click','photo_click_ratio','impression_1k_cost','photo_click_cost','activation'],
					custom_checkbox: false,
					type:"ks"
				},
				{
					label: "飞碟统计数据项：",
					showTitle:["eff_total_pay_money","eff_total_left_money","eff_roi","user_click","eff_total_order_cnt","eff_total_pay_user_cnt","eff_total_pay_user_cost","eff_report_pay_user_cnt","eff_report_pay_user_cost",],
					custom_checkbox: true,
					type:"sjx"
				},
			],
		}
	},
	mounted(){
		let that = this
		
		// that.search_button_loading = true
		
		that.body_width = document.body.clientWidth - 100 // 筛选条件大盒子的宽度
		console.log("body_width",that.body_width);
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			if(res.show_control){
				nn = nn + res.width
			}
		})
		that.table_scroll_width = nn + 30 + 30
		
		
		// 获取29天前日期
		// that.startTime = this.$getBeforeDay(29)
		
		// 获取当天
		that.endTime = this.$getThisDay()
		that.startTime = this.$getThisDay() 
		
		
		// putDataMenu().then(res=>{
		// 	console.log("获取搜索条件",res);
		// 	that.filterData = res.data.data.filter
		// })
		
		marketersDataSelectTg().then(res=>{
			console.log("获取推广人员",res);
			that.tgSelect = res.data.data.list
		})
		
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		handleChangeB(e){
			console.log(e);
			this.r_media_platform = e
		},
		handleChangeC(e){
			console.log(e);
			this.r_plan_type = e
		},
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				this.content_type = e.value
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
				
				this.searchButton()
			}
			
			
		},
		
		// 请选择投手
		handleChangeA(e){
			console.log(e);
			this.r_user_id = e
		},
		
		
		// 搜索
		searchButton(type,button_type){
			let that = this
			that.search_button_loading = true
			
			if(type == 'button'){
				that.r_page = 1
			}
			
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),
				
				// user_id: that.r_user_id, // 投手
				media_platform: that.r_media_platform, // 媒体平台
				plan_type: that.r_plan_type, // 计划类型
			}
			if(that.r_sort_field){
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			if(button_type != "导出"){
				marketersDataDesignList(r_data).then(res=>{
					console.log("搜索结果",res)
					that.search_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.table_total = res.data.data.total
						that.tableShowData = res.data.data.data
						that.tableSumData = res.data.data.sum
					}
					else {
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
					
					// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
					setTimeout(()=>{
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
					},100)
					
				}).catch(err=>{
					console.log(err)
					that.$message.error("搜索失败，可能是网络出现问题");
				})
			}
			else { // 导出
				r_data.report = 1
				marketersDataDesignList(r_data).then(res=>{
					console.log("搜索结果",res)
					that.search_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						// that.$message.success("导出成功");
						that.$confirm({
							title: '导出成功',
							icon:"exclamation-circle",
							class:'jlzh',//类名
							okText: "前往下载任务",
							cancelText: "取消",
							content: h => <div >点击按钮前往-下载任务</div>,
							onOk() {
							  console.log('OK');
							  const { href } = that.$router.resolve('/downTask')
							  window.open(href, '_blank');
							},
							onCancel() {
							  console.log('Cancel');
							},
							
						});
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				})
			}
			
		},
		// 导出
		exportButton(){
			this.searchButton('','导出')
		},
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton()
		},
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				that.tableThClick(index, th_status, that.rableTitle[index].type)
				// this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		
		showCusttomTable(){
			this.custtom_visible = true
		},
		// 数据项————————
		onChangeSJ(e,index,d_tem){
			this.rableTitle[index].show_control = e.target.checked
			console.log(`checked = ${e.target.checked} + ${index}`);
			// 重新计算表格宽度
			this.computeTableWidth()
			
			// 检测子项是否都选中，子项全部选中，则父项也要跟着选中。子项有一个没有被勾选，则父项也要取消勾选
			let ccccc = true
			d_tem.showTitle.forEach(res=>{
				this.rableTitle.forEach(t_es=>{
					if(res == t_es.type && !t_es.show_control){ // 表示有勾选
						ccccc = false
					}
				})
			})
			d_tem.custom_checkbox = ccccc
		},
		// 自定义列的小标题前的选择框
		checkboxCustom(e,d_tem){
			d_tem.custom_checkbox = e.target.checked
			
			this.rableTitle.forEach(res=>{
				d_tem.showTitle.forEach(d_es=>{
					if(res.type == d_es){
						if(e.target.checked){ // 要进行选中
							res.show_control = true
						}
						else {
							res.show_control = false
						}
					}
				})
			})
			// 重新计算表格宽度
			this.computeTableWidth()
		},
		// 自定义列弹窗确认按钮
		customTd(){
			this.custtom_visible = false
		},
		// 计算表格宽度
		computeTableWidth(){
			let that = this
			let nn = 0
			that.rableTitle.forEach((res,index)=>{
				if(res.show_control){
					nn = nn + res.width
				}
			})
			that.table_scroll_width = nn + 30 + 30
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
	},
	filters: {
		dayToFixed(e){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",e)
			if(Object.keys(e).length > 0){
				let v = Number(e.charge_money)/Number(e.cost)
				return v.toFixed(2)
			}
			else {
				return '-'
			}
			
		},
		mediaFilters(e){ // 媒体平台
			let fff = ""
			if(e == 1){
				fff = "巨量"
			}
			else if(e == 2){
				fff = "腾讯ADQ"
			}
			else if(e == 3){
				fff = "腾讯MP"
			}
			else if(e == 4){
				fff = "百度"
			}
			else if(e == 5){
				fff = "快手"
			}
			else {
				fff = "其他"
			}
			return fff
		},
		planFilters(e){ // 计划类型
			let fff = ""
			if(e == 1){
				fff = "巨量1.0"
			}
			else if(e == 2){
				fff = "巨量2.0"
			}
			else if(e == 3){
				fff = "ADQ广告"
			}
			else if(e == 4){
				fff = "MP广告"
			}
			else if(e == 5){
				fff = "百度单元"
			}
			else if(e == 6){
				fff = "快手广告组"
			}
			else {
				fff = "其他"
			}
			return fff
		},
	}
}
</script>

<style scoped>
.title-tab-box {
	color: #313a46;
	padding: 8px 20px;
	border: 1px solid #ccc;
	cursor: pointer;
}

.title-tab-box-selected {
	color: #62a8ea;
	border: 1px solid #62a8ea;
}
	
/* 表格非公共内容 */
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}
.table-th-cell {
	min-height: 63px;
}

.custom-title {
	font-size: 15px;
	font-weight: 600;
	margin-bottom: 10px;
}
.custom-cell-box {
	display:flex;
	flex-wrap: wrap;
	padding-left: 20px;
	margin-bottom:20px;
}
</style>